import randomVideo from "./randomVideo";
import {iframeReady} from "./youtubeApiInit"

// --------------------
//      FULLPAGE  
// --------------------

//fullpage_default
const Fullpage = function (fp) {
  if ($(fp).length) {
    $(fp).fullpage({
      navigation: true,
      scrollOverflow: false,
      responsiveWidth: 767,
      responsiveHeight: 450,
      verticalCentered: false,
      lazyLoading: true,
      onLeave: function (index, nextIndex, direction, anchorLink) {
        var gallery = $('#fullpage .section:nth-child(' + index + ') .carousel.slick-initialized');

        if (gallery.length) {
          gallery.slick('slickPause');
          clearTimeout(window.bannerVideoTimer);
          clearTimeout(window.bannerVideoTimer2);
        }
      },
      afterLoad: function (anchorLink, index) {
        //console.log('afterLoad');

        var $this = $(this);

        var currentSection = $('#fullpage .section:nth-child(' + index + ')'),
          gallery = currentSection.find('.carousel.autoplay.slick-initialized'),
          galleryVideo = $('#fullpage .section:nth-child(' + index + ') .carousel.slick-initialized .slick-current video'),
          galleryVideoIframe = $('#fullpage .section:nth-child(' + index + ') .carousel.slick-initialized .slick-current .video-iframe');

        if (gallery.length && !galleryVideo.length && !galleryVideoIframe.length) {
          gallery.slick('slickPlay');
        } else if (gallery.length && galleryVideo.length) {
          galleryVideo[0].play();
        } else if (gallery.length && galleryVideoIframe.length) {
          galleryVideoIframe.each(function (index, element) {
            youTubePlayers.forEach(e => {
              if (e.a.id === element.id) {
                e.mute();
                e.playVideo();
              }
            });
          });
        }

        if (currentSection.hasClass('fp-nav-dark')) {
          $('#fp-nav').addClass('fp-nav-dark');
        } else {
          $('#fp-nav').removeClass('fp-nav-dark');
        }

        const section3Video = (() => {
          const $videoContainer = currentSection.find('#videoContainer');

          if ($videoContainer.length) {

            if (!$videoContainer.hasClass('initiated')) {
              if ($(window).width() >= 768) {
                randomVideo($videoContainer);
              }
            } else {
              if ($videoContainer.find('.playing video').length) {
                $videoContainer.find('.playing video')[0].play();
              }

              if($videoContainer.find('.playing .video-iframe').length) {
                let youtubeVideo = $videoContainer.find('.playing .video-iframe').prop('id');
  
                youTubePlayers.forEach(e => {
                  if(e.a.id === youtubeVideo) {
                    e.mute();
                    e.playVideo();
                  }
                });
              }
              
            }
          }
        })();

        const section5Video = (() => {
          const videoIframe = currentSection.find('.video-iframe-autoplay').prop('id');

          iframeReady(function(e) {
            e.mute();
            e.playVideo();
          }, videoIframe);
          
        })();

      },
      afterRender: function () {
        // console.log('afterRender');

        if ($(fp).find('.section').length > 1) {
          $('#fp-nav').show();
        }
      },
      afterResize: function () {
        //console.log('afterResize');
      },
      afterSlideLoad: function (anchorLink, index, slideAnchor, slideIndex) {
        // console.log('afterSlideLoad');
      },
      onSlideLeave: function (anchorLink, index, slideIndex, direction, nextSlideIndex) {
        // console.log('onSlideLeave');        
      }
    });
  }
};


function getSectionByIndex(index) { 
  return $('.section').eq(index - 1); 
} 

function isVisible(section) { 
  return $(section).is(':visible'); 
}

function getNearestVisibleSectionIndex(index, direction, section) {
  var step = direction === 'up' ? -1 : 1,
      sectionsCount = $(section).length;

  while (index >=0 && index < sectionsCount && !isVisible(getSectionByIndex(index))) {
      index += step;
  }

  return index === sectionsCount ? -1 : index;
}

const toggleProductMenu = (index) => {
  const $sections = $('.section'),
    sectionIndex = index || $sections.filter('.active').index() + 1,
    $productMenu = $('.productMenu');

  $sections.each(function (index, element) {
    const $element = $(element);

    if($(element).index() + 1 === sectionIndex) {
      const activeSectionId = $element.attr('id');
      
      $productMenu.find(`a[href="#${activeSectionId}"]`).addClass('active');
    }            
  });
}

//fullpage-page
const FullpagePrimary = function (fp) {
  if ($(fp).length) {
    $(fp).fullpage({
      navigation: true,
      scrollOverflow: true,
      responsiveWidth: 767,
      responsiveHeight: 450,
      verticalCentered: false,
      scrollOverflowOptions: {
        disablePointer: true
      },
      onLeave: function(index, nextIndex, direction) {
        if ($(window).width() >= 768) {
          var nextSection = getSectionByIndex(nextIndex),
            section = '.section';          
    
          if(!isVisible(nextSection)) {
            var sectionIndex = getNearestVisibleSectionIndex(nextIndex, direction, section);

            if (sectionIndex !== -1) {
              $.fn.fullpage.moveTo(sectionIndex);
            }
    
            return false;
          } else {
            $('.productMenu').find('a').removeClass('active');
          }
        }
      },
      afterLoad: function (anchorLink, index) {        
        toggleProductMenu(index);        
      },
      afterRender: function () {
        let $fpNav = $('#fp-nav'),
          hiddenSectionsIndex = [];

        toggleProductMenu();        

        if ($(fp).find('.section').length <= 1) {
          $fpNav.hide();
        } else {
          $fpNav.addClass('fp-nav-dark');
        }

        $(this).find('.section:hidden').each(function (index, element) {          
          hiddenSectionsIndex.push($(element).index());
        });        

        $fpNav.find('li').each(function (index, element) {
          const $this = $(element);

          hiddenSectionsIndex.forEach(function(sectionIndex) {
            if($this.index() === sectionIndex) {              
              $this.hide();
            }
          });
        });

        const productSpecificationHeight = () => {
          let timer;

          const init = () => {
            const col = $('section.page.product-specification').not('.product-specification-sm').find('.col-wrapper');

            col.css('min-height', 0);
            col.css('min-height', col.parent().height() - 50);
          };

          const refresh = function () {
            if (timer) {
              clearTimeout(timer);
            }
            timer = setTimeout(init, 100);
          };

          init();

          $(window).resize(function () {
            refresh();
          });
        }
        productSpecificationHeight();

      }
    });
  }
};

export {
  Fullpage,
  FullpagePrimary
};


// WEBPACK FOOTER //
// ./src/js/components/fullpage.js